import React, { useEffect } from 'react';
import useTranslation from '../hooks/useTranslation';

export default function HelpDropdown({ open, onClose }) {
  const { t } = useTranslation();

  useEffect(() => {
    function handleKey(e) {
      if (e.key === 'Escape') onClose();
    }
    function handleClick(e) {
      if (e.target.classList.contains('help-dropdown-bg')) onClose();
    }
    if (open) {
      window.addEventListener('keydown', handleKey);
      document.addEventListener('mousedown', handleClick);
    }
    return () => {
      window.removeEventListener('keydown', handleKey);
      document.removeEventListener('mousedown', handleClick);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="help-dropdown-bg open">
      <div className="help-dropdown-box open">
        <div style={{ padding: '12px 16px' }}>
          <div style={{ fontWeight: 700, fontSize: '1.1rem', marginBottom: '8px' }}>{t('Help & Commands')}</div>
          <div style={{ fontSize: '0.9rem', opacity: 0.8 }}>
            <div style={{ marginBottom: '6px' }}><b>{t('BOT commands:')}</b></div>
            <div>• <b>"{t('login')}"</b> - {t('login screen')}</div>
            <div>• <b>"{t('Signup')}"</b> - {t('signup screen')}</div>
            <div>• <b>"{t('Dashboard')}"</b> - {t('Dashboard screen')}</div>
            <div>• <b>"{t('get started')}"</b> - {t('get started screen')}</div>
            <div>• <b>"{t('Upload')}"</b> - {t('upload option comes')}</div>
            <div>• <b>"{t('record')}"</b> - {t('record options starts')}</div>
            <div>• <b>"{t('Analyse')}"</b> - {t('analyse options comes')}</div>
            <div>• <b>"{t('speechbot')}"</b> {t('or')} <b>"{t('talk to bot')}"</b> - {t('you can chat freely with own native language')}</div>
          </div>
          <div style={{ marginTop: '12px', fontSize: '0.9rem', opacity: 0.8, borderTop: '1px solid #444', paddingTop: '8px' }}>
            <b>{t('Manual option:')}</b>
            <div style={{ marginTop: '4px' }}>{t('Click mic (on/off) - for start and stop recording. Please speak less than 10 sec. We limited for beta version 1 and later on we increase size of recording.')}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
